import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import SectionTitle from './SectionTitle';
import SectionSubTitle from './SectionSubTitle';
import SectionText from './SectionText';
import { device } from '../../../style/Sizes';

// const ImgContainer = styled.div`
//   margin: 100px auto;
//   /* margin-top: 100px; */
//   position: relative;
//   background-image: ${props => `url(${props.src})`};
//   /* background-image: ${() => `url(${BgImg})`}; */
//   /* background-image: url(${BgImg}); */
//   background-repeat: no-repeat;
//   background-color: #cccccc;
//   background-position: center;
//   background-size: contain;
//   width: 100%;
//   min-height: 200px;
//   max-height: 500px;
//   height: auto;
//   max-width: 1000px;
//   /* background-color: yellow; */
// `;

const StyledSectionContainer = styled.div`
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  opacity: ${props => (props.visible ? '1' : '0')};
  padding-top: ${props => (props.visible ? '0' : '100px')};
  height: auto;
  max-width: 1000px;
  width: 100%;
  margin: 0 auto
    ${props =>
      props.containerMarginBottom === 'default'
        ? '120px'
        : props.containerMarginBottom}
    auto;
  transition: ${props => (props.noTransition ? '0s' : 'opacity 2s, padding-top 1s')};

  @media ${device.maxMobileL} {
    margin: 0 auto
    ${props =>
      props.containerMarginBottom === 'default'
        ? '80px'
        : props.containerMarginBottom}
    auto;
  }
`;

const ImgContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${props => props.imgContainerHeight};
  max-height: ${props => props.imgContainerMaxHeight};
  min-height: ${props => props.imgContainerMinHeight};
  background-color: #F5F5F5;
  /* background-color: #e6e9ea; */
  /* background-color: #C0C8CB; */
  /* background-color: gainsboro; */
`;

const StyledImg = styled.img`
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: auto;
  margin-top: ${props => props.imgMarginTop};
  max-width: ${props => props.fullWidth ? '100%' : '95%'};
  height: auto;
  max-height: ${props => props.imgHeight};
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

const SectionContainer = props => {
  const rectRef = React.createRef();
  const [compVisible, setCompVisible] = useState(false);

  useEffect(() => {
    const viewHeight = document.documentElement.clientHeight;
    const rect = rectRef.current.getBoundingClientRect();
    if (rect.top < (viewHeight / 3) * 2.4) {
      setCompVisible(true);
    }
    // console.log(rect);
    // console.log(viewHeight);
  }, [compVisible, rectRef]);

  return (
    <StyledSectionContainer
      noTransition={props.noTransition}
      ref={rectRef}
      visible={compVisible}
      containerMarginBottom={props.containerMarginBottom}
    >
      <SectionTitle
        sectionTitle={props.sectionTitle}
        titleMarginBottom={props.titleMarginBottom}
      />
      <SectionSubTitle
        sectionSubTitle={props.sectionSubTitle}
        subTitleMarginBottom={props.subTitleMarginBottom}
      />
      <SectionText
        sectionText={props.sectionText}
        textMarginBottom={props.textMarginBottom}
      />
      <ImgContainer
        imgContainerHeight={props.imgContainerHeight}
        imgContainerMaxHeight={props.imgContainerMaxHeight}
        imgContainerMinHeight={props.imgContainerMinHeight}
      >
        <StyledImg
          src={props.src}
          alt={props.alt}
          fullWidth={props.fullWidth}
          imgHeight={props.imgHeight}
          imgMarginTop={props.imgMarginTop}
        />
      </ImgContainer>
    </StyledSectionContainer>
  );
};

export default SectionContainer;
